/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Copy_LabelInputs */



/**
* | output |
* | --- |
* | "Copy selected events" |
*
* @param {Context_Menu_Copy_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_copy_label = /** @type {((inputs?: Context_Menu_Copy_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Copy_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Copier les evenements selectionnes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausgewählte Ereignisse kopieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Copia gli eventi selezionati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Скопировать выбранные события")
	if (locale === "es") return /** @type {LocalizedString} */ ("Copiar eventos seleccionados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("复制所选事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベントをコピー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित घटनाओं की प्रतिलिपि बनाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Copiar eventos selecionados")
	return /** @type {LocalizedString} */ ("Copy selected events")
});